import { useDisclosure } from '@chakra-ui/react';
import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import { getAppTheme, userIsSubscriber } from 'components/Utils/theme';
import { useContext, useEffect, useState } from 'react';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;
const useModelButtonNotificacao = () => {
  const { user } = useContext(AccountContext);
  const theme = getAppTheme(userIsSubscriber(user));
  const modalNotificacaoHome = useDisclosure();
  const [hiddenButton, setHiddenButton] = useState(true);
  const [cacheNotificacao, setNotificacao] = useState([]);

  async function fetchData() {
    await api(`${ENDPOINT}/cache/schedule-changes`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(async (res) => {
        return res.json();
      })
      .then(async (resposta) => {
        if (resposta.length > 0) {
          setNotificacao(resposta);
          setHiddenButton(false);
        } else {
          setHiddenButton(true);
          setNotificacao([]);
        }
      });
  }

  useEffect(() => {
    fetchData();
    const timeout = setInterval(() => {
      fetchData();
    }, 30 * 1000);
    return () => {
      if (timeout) clearInterval(timeout);
    };
  }, [setHiddenButton]);

  return {
    theme,
    modalNotificacaoHome,
    hiddenButton,
    cacheNotificacao,
    fetchData,
  };
};

export default useModelButtonNotificacao;
